import Model, { attr, belongsTo } from '@ember-data/model';

export default class MessagingProfileModel extends Model {
  @belongsTo('messaging-system-user', { async: false, inverse: null }) systemUser;

  @attr('boolean') isAway;
  @attr('boolean') isSuperUser;

  @attr('string') awayMessageText;
  @attr('string') externalScope;
  @attr('string') name;

  @attr() unreadConversationIds;
}
